import { Controller } from '@hotwired/stimulus';

import AllocationOverTimeGraphController from './allocation-over-time-graph-controller';
import ReturnsGraphController from './returns-graph-controller';

export default class extends Controller {
  redrawGraphs() {
    if (this.returnsGraphController) {
      this.returnsGraphController.draw();
    }
    if (this.allocationOverTimeGraphController) {
      this.allocationOverTimeGraphController.draw();
    }
  }

  get returnsGraphTarget() {
    return this.element.querySelector('.AllocationReview-returnsProjectionComponent [data-controller="returns-graph"]');
  }

  get returnsGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.returnsGraphTarget!,
      'returns-graph'
    ) as ReturnsGraphController;
  }

  get allocationOverTimeGraphTarget() {
    return this.element.querySelector(
      '.AllocationReview-allocationOverTimeComponent [data-controller="allocation-over-time-graph"]'
    );
  }

  get allocationOverTimeGraphController() {
    return this.application.getControllerForElementAndIdentifier(
      this.allocationOverTimeGraphTarget!,
      'allocation-over-time-graph'
    ) as AllocationOverTimeGraphController;
  }
}
